import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { ja } from "date-fns/locale";
import { AuthConsumer, AuthProvider } from "src/auth/context/jwt";
import MotionLazy from "src/components/animate/motion-lazy";
import ProgressBar from "src/components/progress-bar";
import { SettingsProvider } from "src/components/settings";
import Router from "src/routes/sections";
import ThemeProvider from "src/theme";

export default function App() {
  return (
    <AuthProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
        <SettingsProvider
          defaultSettings={{
            themeMode: "light",
            themeDirection: "ltr",
            themeContrast: "default",
            themeLayout: "vertical",
            themeColorPresets: "red",
            themeStretch: true,
          }}
        >
          <ThemeProvider>
            <MotionLazy>
              <ProgressBar />
              <AuthConsumer>
                <Router />
              </AuthConsumer>
            </MotionLazy>
          </ThemeProvider>
        </SettingsProvider>
      </LocalizationProvider>
    </AuthProvider>
  );
}
